/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements, applyPolyfills } from '@pallet/pallet/dist/loader';
applyPolyfills().then(() => defineCustomElements());
export const PalAccordion = /*@__PURE__*/ createReactComponent('pal-accordion');
export const PalAccordionItem = /*@__PURE__*/ createReactComponent('pal-accordion-item');
export const PalAdvancedDataTable = /*@__PURE__*/ createReactComponent('pal-advanced-data-table');
export const PalAlert = /*@__PURE__*/ createReactComponent('pal-alert');
export const PalBadge = /*@__PURE__*/ createReactComponent('pal-badge');
export const PalBreadcrumbs = /*@__PURE__*/ createReactComponent('pal-breadcrumbs');
export const PalButton = /*@__PURE__*/ createReactComponent('pal-button');
export const PalButtonGroup = /*@__PURE__*/ createReactComponent('pal-button-group');
export const PalCard = /*@__PURE__*/ createReactComponent('pal-card');
export const PalCheckbox = /*@__PURE__*/ createReactComponent('pal-checkbox');
export const PalCheckboxGroup = /*@__PURE__*/ createReactComponent('pal-checkbox-group');
export const PalDataTable = /*@__PURE__*/ createReactComponent('pal-data-table');
export const PalDataTableCell = /*@__PURE__*/ createReactComponent('pal-data-table-cell');
export const PalDataTableRow = /*@__PURE__*/ createReactComponent('pal-data-table-row');
export const PalDataTableTbody = /*@__PURE__*/ createReactComponent('pal-data-table-tbody');
export const PalDataTableThead = /*@__PURE__*/ createReactComponent('pal-data-table-thead');
export const PalDatePicker = /*@__PURE__*/ createReactComponent('pal-date-picker');
export const PalDatePickerInput = /*@__PURE__*/ createReactComponent('pal-date-picker-input');
export const PalDropdown = /*@__PURE__*/ createReactComponent('pal-dropdown');
export const PalDropdownItem = /*@__PURE__*/ createReactComponent('pal-dropdown-item');
export const PalHeader = /*@__PURE__*/ createReactComponent('pal-header');
export const PalHeaderItem = /*@__PURE__*/ createReactComponent('pal-header-item');
export const PalIcon = /*@__PURE__*/ createReactComponent('pal-icon');
export const PalModal = /*@__PURE__*/ createReactComponent('pal-modal');
export const PalNumberInput = /*@__PURE__*/ createReactComponent('pal-number-input');
export const PalPagination = /*@__PURE__*/ createReactComponent('pal-pagination');
export const PalProgressBar = /*@__PURE__*/ createReactComponent('pal-progress-bar');
export const PalRadioButton = /*@__PURE__*/ createReactComponent('pal-radio-button');
export const PalRadioButtonGroup = /*@__PURE__*/ createReactComponent('pal-radio-button-group');
export const PalSidenav = /*@__PURE__*/ createReactComponent('pal-sidenav');
export const PalSidenavItem = /*@__PURE__*/ createReactComponent('pal-sidenav-item');
export const PalSpinner = /*@__PURE__*/ createReactComponent('pal-spinner');
export const PalStep = /*@__PURE__*/ createReactComponent('pal-step');
export const PalStepBar = /*@__PURE__*/ createReactComponent('pal-step-bar');
export const PalStepPanel = /*@__PURE__*/ createReactComponent('pal-step-panel');
export const PalStepPanels = /*@__PURE__*/ createReactComponent('pal-step-panels');
export const PalStepper = /*@__PURE__*/ createReactComponent('pal-stepper');
export const PalTab = /*@__PURE__*/ createReactComponent('pal-tab');
export const PalTabBar = /*@__PURE__*/ createReactComponent('pal-tab-bar');
export const PalTabPanel = /*@__PURE__*/ createReactComponent('pal-tab-panel');
export const PalTabPanels = /*@__PURE__*/ createReactComponent('pal-tab-panels');
export const PalTabs = /*@__PURE__*/ createReactComponent('pal-tabs');
export const PalTag = /*@__PURE__*/ createReactComponent('pal-tag');
export const PalTextArea = /*@__PURE__*/ createReactComponent('pal-text-area');
export const PalTextInput = /*@__PURE__*/ createReactComponent('pal-text-input');
export const PalToggle = /*@__PURE__*/ createReactComponent('pal-toggle');
//# sourceMappingURL=components.js.map